import React, {useEffect, useRef, useState} from "react";
import {AddMenuStyles} from "components/atoms/MenuManagement/MenuManagement.styles";
import {useForm} from "components/molecules/Form";
import Field from "components/molecules/Field";
import Form from "components/molecules/Form/Form";
import Button from "components/molecules/Button";
import {IoMdArrowDropdown} from "react-icons/io";
import {MdDelete} from "react-icons/md";
import menuStoreService from "services/menu-storeService";
import {useSelector} from "react-redux";
import Toast from "components/molecules/Toast";

const SubChoiceModal = ({ isEdit = false, onClose, onSave, initialSubChoices = [] }) => {
    const [form] = useForm();
    const [formState, setFormState] = useState([{ subChoiceName: "", price: "", calories: "" }]);

    useEffect(() => {
        if (isEdit && Array.isArray(initialSubChoices)) {
            const updatedState = initialSubChoices.map(item => ({
                subChoiceName: item.subChoiceName || item.name || item.choiceName || "",
                price: item.price ?? "",
                calories: item.calories ?? "",
            }));
            setFormState(updatedState.length ? updatedState : [{ subChoiceName: "", price: "", calories: "" }]);

            const fieldValues = updatedState
                .map((item, ind) => ({
                    [`subChoiceName${ind}`]: item.subChoiceName,
                    [`price${ind}`]: item.price,
                    [`calories${ind}`]: item.calories,
                }))
                .reduce((acc, curr) => ({ ...acc, ...curr }), {});
            form.setFieldsValue(fieldValues);
        }
    }, [isEdit, initialSubChoices, form]);

    const addFeilds = () => {
        const newFormState = [...formState, { subChoiceName: "", price: "", calories: "" }];
        
        // Re-sync all form field values to prevent validation errors
        setTimeout(() => {
            newFormState.forEach((item, ind) => {
                form.setFieldsValue({
                    [`subChoiceName${ind}`]: item.subChoiceName,
                    [`price${ind}`]: item.price,
                    [`calories${ind}`]: item.calories,
                });
            });
        }, 0);
        
        setFormState(newFormState);
    };

    const handleFieldChange = (index, field, value) => {
        setFormState(prev => prev.map((item, i) => (i === index ? { ...item, [field]: value } : item)));
        form.setFieldsValue({ [`${field}${index}`]: value });
    };

    const removeVariation = index => {
        const newFormState = formState.filter((_, i) => i !== index);
        
        // Re-sync all form field values after removal to prevent validation errors
        setTimeout(() => {
            newFormState.forEach((item, ind) => {
                form.setFieldsValue({
                    [`subChoiceName${ind}`]: item.subChoiceName,
                    [`price${ind}`]: item.price,
                    [`calories${ind}`]: item.calories,
                });
            });
        }, 0);
        
        setFormState(newFormState);
    };

const handleSubmit = () => {
    for (let i = 0; i < formState.length; i++) {
        const it = formState[i];
        if (!it.subChoiceName) {
            return; // Choice name is mandatory
        }
    }

    const transformed = formState.map(it => ({
        subChoiceName: it.subChoiceName,
        price: it.price === "" ? 0 : parseFloat(it.price), // null = free
        calories: it.calories === "" ? null : parseFloat(it.calories),
    }));

    if (onSave) onSave(transformed);
    if (onClose) onClose();
};

    return (
        <AddMenuStyles>
            <Form form={form} onSubmit={handleSubmit}>
                {formState.map((item, ind) => (
                    <div key={ind}>
                        <div className="delete-btn ">
                            <Button danger sm onClick={() => removeVariation(ind)} type="button">
                                <MdDelete />
                                Delete
                            </Button>
                        </div>

                        <div className="combine-fields">
                            <Form.Item
                                label="Choice Name"
                                placeholder="Choice Name"
                                type="text"
                                rounded
                                name={`subChoiceName${ind}`}
                                value={item.subChoiceName}
                                onChange={e => handleFieldChange(ind, "subChoiceName", e.target.value)}
                                lg
                                $bgWhite>
                                <Field />
                            </Form.Item>

                 <Form.Item
    label="Enter Price"
    placeholder="Leave blank for free"
    type="number"
    min={0}
    step="any"
    rounded
    name={`price${ind}`}
    value={item.price}
    onChange={e => handleFieldChange(ind, "price", e.target.value)}
    lg
    $bgWhite>
    <Field />
</Form.Item>
                        </div>

                     <Form.Item
    label="Calories (per serving)"
    placeholder="e.g., 250 or 4.0"
    type="number"
    min={0}
    step="any"
    rounded
    name={`calories${ind}`}
    value={item.calories}
    onChange={e => handleFieldChange(ind, "calories", e.target.value)}
    lg
    $bgWhite>
    <Field suffix="kcal" />
</Form.Item>
                    </div>
                ))}

                <hr />
                <div className="btn-holder">
                    <div className="btn">
                        <Button gray type="button" onClick={addFeilds}>
                            + Add Choice
                        </Button>
                    </div>
                    <div className="btn">
                        <Button type="submit">Save Choice</Button>
                    </div>
                </div>
            </Form>
        </AddMenuStyles>
    );
};

export default SubChoiceModal;
